<style type="text/css">
.blog_table_footer {
    display: flex;
    box-sizing: content-box;
    padding-top: 10px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    justify-content: space-between;
}
</style>
<template>
    <div>
        <div style="display: flex;justify-content: flex-start">
            <el-input placeholder="通过标题搜索该分类下的博客..." prefix-icon="el-icon-search" v-model="keywords" style="width: 400px" size="mini"></el-input>
            <el-button type="primary" icon="el-icon-search" size="mini" style="margin-left: 3px" @click="searchClick">搜索</el-button>
            <el-select v-model="option" style="margin-left: 20px" @change="handleSelectChange" placeholder="通过类型搜索改分类下的产品...">
                <el-option v-for="item in options" :key="item.id" :label="item.cateName" :value="item.id"></el-option>
            </el-select>
        </div>
        <!--<div style="width: 100%;height: 1px;background-color: #20a0ff;margin-top: 8px;margin-bottom: 0px"></div>-->
        <el-table ref="multipleTable" :data="articles" tooltip-effect="dark" style="" max-height="390" v-loading="loading">
            <el-table-column type="index" label="序号" width="55" align="left"></el-table-column>
            <el-table-column label="标题" width="140" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="color: #409eff;cursor: pointer" @click="itemClick(scope.row)">{{ scope.row.title }}</span>
                </template>
            </el-table-column>
            <el-table-column label="最近编辑时间" width="140" align="left">
                <template slot-scope="scope">
                    {{ scope.row.editTime | formatDateTime }}
                </template>
            </el-table-column>
            <el-table-column label="资讯图片" width="200" align="left">
                <template slot-scope="scope">
                    <el-popover placement="top" width="200" trigger="hover">
                        <img slot="reference" :src="scope.row.image" style="width: 140px; height: 60px" />
                        <img style="max-width: 200px" :src="scope.row.image" />
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="nickname" label="作者" width="120" align="left"></el-table-column>
            <el-table-column prop="cateName" label="所属分类" width="120" align="left"></el-table-column>
            <el-table-column label="操作" align="left" v-if="showEdit || showDelete">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" v-if="showEdit">编辑</el-button>
                    <el-button size="mini" @click="handleRestore(scope.$index, scope.row)" v-if="showRestore">还原</el-button>
                    <el-button size="mini" @click="handleUpload(scope.$index, scope.row)" v-if="showUpload">更新图片</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)" v-if="showDelete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="blog_table_footer">
            <span></span>
            <el-pagination
                background
                :page-size="pageSize"
                layout="prev, pager, next"
                :total="totalCount"
                @current-change="currentChange"
                v-show="this.articles.length > 0"
            ></el-pagination>
        </div>
        <el-dialog title="添加图片" :visible.sync="dialogVisible" width="440px">
            <el-form :model="articalForm" status-icon ref="articalForm" label-width="70px">
                <el-form-item label="资讯图片" prop="form_image" align="left">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        action="string"
                        accept="image/jpeg,image/png,image/jpg"
                        list-type="picture-card"
                        :before-upload="onBeforeUploadImage"
                        :http-request="UploadImage"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-change="fileChange"
                        :file-list="fileList"
                    >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">
                            只能上传jpg/jpeg/png文件，且不超过1M
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm">提交</el-button>
                    <el-button @click="resetForm('articalForm')">重置</el-button>
                    <el-button @click="dialogVisible = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :visible.sync="dialogImageVisible">
            <img width="100%" :src="articalForm.form_image" alt />
        </el-dialog>
    </div>
</template>

<script>
import { postRequest, putRequest, getRequest, uploadFileRequest } from '@/utils/api';
import { getAllArticle, getCateAll } from '@/api';
export default {
    data() {
        return {
            articles: [],
            options: [],
            option: '',
            loading: false,
            currentPage: 1,
            totalCount: -1,
            pageSize: 6,
            keywords: '',
            dustbinData: [],
            dialogVisible: false,
            dialogImageVisible: false,
            articalForm: {
                form_image: '',
            },
            fileList: [],
        };
    },
    mounted: function() {
        this.refresh();
        var _this = this;
        this.loading = true;
        this.loadBlogs(1, this.pageSize);
        var _this = this;
        window.bus.$on('blogTableReload', function() {
            _this.loading = true;
            _this.loadBlogs(_this.currentPage, _this.pageSize);
        });
    },
    methods: {
        async refresh() {
            try {
                const { data, status } = await getCateAll();
                if (status === 200) {
                    this.options = data;
                }
            } catch (error) {}
        },

        handleSelectChange(val) {
            this.loadBlogs();
        },

        onBeforeUploadImage(file) {
            const isIMAGE = file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
            const isLt1M = file.size / 1024 / 1024 < 2;
            if (!isIMAGE) {
                this.$message.error('上传文件只能是图片格式!');
            }
            if (!isLt1M) {
                this.$message.error('上传文件大小不能超过 2MB!');
            }
            return isIMAGE && isLt1M;
        },

        UploadImage(param) {
            const formData = new FormData();
            formData.append('image', param.file);
            this.articalForm.form_image = formData;
        },

        fileChange(file) {
            this.$refs.upload.clearFiles(); //清除文件对象
            this.fileList = [{ name: file.name, url: file.url }]; // 重新手动赋值filstList， 免得自定义上传成功了, 而fileList并没有动态改变， 这样每次都是上传一个对象
        },

        handlePictureCardPreview(file) {
            this.articalForm.form_image = file.url;
            this.dialogImageVisible = true;
        },

        handleRemove(file, fileList) {
            // console.log(file, fileList);
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            // this.fileList = [];
            this.$refs.upload.clearFiles();
        },
        submitForm() {
            const { form_image, id, image } = this.articalForm;
            if (form_image === '' || form_image === null) {
                return this.failedInfo('请上传资讯展示图片');
            }
            if (image) {
                this.deleteImage(image);
            }
            // this.loading = true;
            uploadFileRequest('/uploadimg', form_image).then(result => {
                const { code, message, data: image_data } = result.data;
                if (code === 200) {
                    getRequest('/article/' + id).then(resp => {
                        if (resp.status == 200) {
                            const datas = { ...resp.data, image: image_data };
                            const { id, title, mdContent, htmlContent, cid, statedynamicTags } = datas;
                            postRequest('/article/', { id, title, mdContent, state: 1, htmlContent, cid, statedynamicTags, image: image_data })
                                .then(result => {
                                    const { status, data } = result;
                                    if (status == 200 && data.status === 'success') {
                                        this.dialogVisible = false;
                                        this.successInfo('添加成功');
                                        this.loadBlogs();
                                    } else {
                                        this.failedInfo('添加失败');
                                    }
                                })
                                .catch(() => {
                                    this.failedInfo('服务器错误');
                                });
                        } else {
                            _this.$message({ type: 'error', message: '页面加载失败!' });
                        }
                    });
                }
            });
        },

        deleteImage(key) {
            const path = key.slice(key.lastIndexOf('/') + 1, key.length);
            postRequest('/deleteimg', { filename: path }).then(res => {
                // console.log(res);
            });
        },

        searchClick() {
            this.loadBlogs(1, this.pageSize);
        },

        itemClick(row) {
            this.$router.push({ path: '/blogDetail', query: { aid: row.id } });
        },

        //翻页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.loading = true;
            this.loadBlogs(currentPage, this.pageSize);
        },
        async loadBlogs(page, count) {
            this.loading = true;
            var url = '';
            if (this.state == -2) {
                url = '/admin/article/all' + '?page=' + this.currentPage + '&count=' + this.pageSize + '&keywords=' + this.keywords + '&cid=' + this.option;
            } else {
                url = '/article/all?state=' + this.state + '&page=' + this.currentPage + '&count=' + this.pageSize + '&keywords=' + this.keywords + '&cid=' + this.option;
            }
            const {
                data: { articles, totalCount },
            } = await getAllArticle(url);
            this.articles = articles;
            this.totalCount = totalCount;
            this.loading = false;
        },

        handleEdit(index, row) {
            this.$router.push({
                path: '/editBlog',
                query: { from: this.activeName, id: row.id },
            });
        },

        handleUpload(index, row) {
            this.articalForm = row;
            this.dialogVisible = true;
        },

        handleDelete(index, row) {
            this.dustbinData.push(row.id);
            this.deleteToDustBin(row.state, row);
        },

        handleRestore(index, row) {
            let _this = this;
            this.$confirm('将该文件还原到原处，是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    _this.loading = true;
                    putRequest('/article/restore', {
                        articleId: row.id,
                    }).then(resp => {
                        if (resp.status == 200) {
                            var data = resp.data;
                            _this.$message({
                                type: data.status,
                                message: data.msg,
                            });
                            if (data.status == 'success') {
                                window.bus.$emit('blogTableReload'); //通过选项卡都重新加载数据
                            }
                        } else {
                            _this.$message({
                                type: 'error',
                                message: '还原失败!',
                            });
                        }
                        _this.loading = false;
                    });
                })
                .catch(() => {
                    _this.$message({
                        type: 'info',
                        message: '已取消还原',
                    });
                });
        },
        deleteToDustBin(state, row) {
            var _this = this;
            this.$confirm(state != 2 ? '将该文件放入回收站，是否继续?' : '永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    _this.loading = true;
                    var url = '';
                    if (_this.state == -2) {
                        if (row.image) {
                            this.deleteImage(row.image);
                        }
                        url = '/admin/article/dustbin';
                    } else {
                        url = '/article/dustbin';
                    }
                    putRequest(url, {
                        aids: _this.dustbinData,
                        state: state,
                    }).then(
                        resp => {
                            if (resp.status == 200) {
                                var data = resp.data;
                                _this.$message({
                                    type: data.status,
                                    message: data.msg,
                                });
                                if (data.status == 'success') {
                                    window.bus.$emit('blogTableReload'); //通过选项卡都重新加载数据
                                }
                            } else {
                                _this.$message({
                                    type: 'error',
                                    message: '删除失败!',
                                });
                            }
                            _this.loading = false;
                            _this.dustbinData = [];
                        },
                        resp => {
                            _this.loading = false;
                            _this.$message({
                                type: 'error',
                                message: '删除失败!',
                            });
                            _this.dustbinData = [];
                        }
                    );
                })
                .catch(() => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除',
                    });
                    _this.dustbinData = [];
                });
        },
        tipInfo(info) {
            this.$message({ type: 'info', message: info });
        },
        successInfo(info) {
            this.$message({ type: 'success', message: info });
        },
        failedInfo(info) {
            this.$message({ type: 'error', message: info });
        },
    },
    props: ['state', 'showEdit', 'showDelete', 'activeName', 'showRestore', 'showUpload'],
};
</script>



// WEBPACK FOOTER //
// src/pages/article/BlogTable.vue